import axios from '@/axios.js'

const state = () => ({
    listpegawais: [],
    taskpegawais: [],
    taskofflocations: [],
    taskhitungs: [],
})

const mutations = {
  SET_LISTPEGAWAI (state, payload) {
    state.listpegawais = payload
  },
  SET_TASKPEGAWAI (state, payload) {
    state.taskpegawais = payload
  },
  SET_TASKOFFLOCATION (state, payload) {
    state.taskofflocations = payload
  },
  SET_TASKHITUNG (state, payload) {
    state.taskhitungs = payload
  },
}

const actions = {
  fetchListPegawai ({ commit }) {
    return new Promise((resolve, reject) => {
      axios.get('/list-pegawai')
        .then((response) => {
          commit('SET_LISTPEGAWAI', response.data.data)
          resolve(response.data)
        })
        .catch((error) => { reject(error) })
    })
  },
  fetchTaskPegawai ({ commit }, pilihSet) {
    return new Promise((resolve, reject) => {
      axios.get(`/task-pegawai/${pilihSet.user}/${pilihSet.min}/${pilihSet.max}/${pilihSet.struktur}`)
        .then((response) => {
          commit('SET_TASKPEGAWAI', response.data.data)
          resolve(response.data)
        })
        .catch((error) => { reject(error) })
    })
  },
  fetchTaskOffLocation ({ commit }, pilih) {
    return new Promise((resolve, reject) => {
      axios.get(`/task-offlocation/${pilih.min}/${pilih.max}/${pilih.absen_id}`)
        .then((response) => {
          commit('SET_TASKOFFLOCATION', response.data.data)
          resolve(response.data)
        })
        .catch((error) => { reject(error) })
    })
  },
  fetchTaskHitung ({ commit }, pilih) {
    return new Promise((resolve, reject) => {
      axios.get(`/task-hitung/${pilih.bulan}/${pilih.str}/${pilih.asn}`)
        .then((response) => {
          commit('SET_TASKHITUNG', response.data.data)
          resolve(response.data)
        })
        .catch((error) => { reject(error) })
    })
  },
}

export default {
  isRegistered: false,
  namespaced: true,
  state,
  actions,
  mutations
}